import React from 'react'
import PropTypes from 'prop-types'
import { mergeProps } from 'src/util'
import ContentLoader from '../ContentLoader'
import styles from './CircleLoader.scss'

/**
 * A circle content loader.
 */
const CircleLoader = ({ radius, ...domProps }) => (
  <ContentLoader
    {...mergeProps()(
      { className: styles.loader, style: { width: radius, maxWidth: radius, height: radius, maxHeight: radius } },
      domProps
    )}
  >
    <circle cx="50" cy="50" r="50" />
  </ContentLoader>
)

CircleLoader.defaultProps = {
  ...ContentLoader.defaultProps,
}

CircleLoader.propTypes = {
  ...ContentLoader.propTypes,
  radius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default CircleLoader
